var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-wrap", class: { "white-bg": !_vm.isTransparent } },
    [
      _c("header", { staticClass: "header" }, [
        _c("ul", { staticClass: "header-nav container clearfix" }, [
          _vm.isTransparent
            ? _c("li", { staticClass: "logo", on: { click: _vm.goHome } }, [
                _c("img", {
                  attrs: { src: require("../../assets/img/logo.png") }
                })
              ])
            : _c("li", { staticClass: "logo", on: { click: _vm.goHome } }, [
                _c("img", {
                  attrs: { src: require("../../assets/img/logo_yellow.png") }
                })
              ]),
          _vm._v(" "),
          _c("li", { staticClass: "header-nav-item" }),
          _c(
            "li",
            {
              staticClass: "header-nav-item",
              on: {
                click: function($event) {
                  _vm.$ssvue.collectSendRequest("投资首页-我的资产", "click")
                }
              }
            },
            [
              _c("a", { attrs: { href: _vm.domains.assetLinkurl } }, [
                _vm._v("我的钱包")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "header-nav-item",
              on: {
                click: function($event) {
                  _vm.$ssvue.collectSendRequest("投资首页-记账", "click")
                }
              }
            },
            [_c("a", { attrs: { href: "https://sui.com" } }, [_vm._v("记账")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "header-nav-item",
              on: {
                click: function($event) {
                  _vm.$ssvue.collectSendRequest("投资首页-信息披露", "click")
                }
              }
            },
            [
              _c("router-link", { attrs: { to: "/info" } }, [
                _vm._v("信息披露")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "header-nav-item",
              on: {
                click: function($event) {
                  _vm.$ssvue.collectSendRequest("投资首页-首页", "click")
                }
              }
            },
            [
              _c("router-link", { attrs: { to: "/investment" } }, [
                _vm._v("首页")
              ])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59e7d433", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e7d433","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navHeader/index.vue
// module id = 626
// module chunks = 36